import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { type StudentSearch } from '~entities/student/modal/student-search';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

export interface GetAllStudentsParams {
  limit?: number;
  page?: number;

  name?: string;
  familyName?: string;
  lastName?: string;
  isActive?: 'true' | 'false';
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  tags?: string;
  sessionId?: string;
  groupId?: string;
  classId?: string;
}

export interface GetAllStudentsResponse {
  data: {
    students: Array<StudentSearch>;
    familyNames: Array<string>;
    lastNames: Array<string>;
    costumeSizes: Array<string>;
    tags: Array<{ _id: string; name: string }>;
  };
  pagination: Pagination;
}

interface Pagination {
  totalCount: number;
  totalPages: number;
  limit: number;
  page: number;
}

export const getAllStudentsWithSearchAPI = async (
  params?: GetAllStudentsParams,
) => {
  const response = await baseAPI.get<GetAllStudentsResponse>(
    `students/search/student`,
    {
      params,
    },
  );
  return response.data;
};

export const getAllStudentsWithSearchOptions = (
  params?: GetAllStudentsParams,
) => {
  return queryOptions({
    queryKey: QUERY_KEYS.STUDENTS_WITH_SEARCH(params),
    queryFn: () => getAllStudentsWithSearchAPI(params),
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000, // Data remains fresh for 5 minutes
  });
};

export const useGetAllStudentsWithSearch = (params?: GetAllStudentsParams) => {
  return useQuery(getAllStudentsWithSearchOptions(params));
};
